import React from "react";

type A11yButtonOptions = {
  onClick?: React.MouseEventHandler;
  disabled?: boolean;
  allowTabWhenDisabled?: boolean;
  activateOnSpace?: boolean; // default true
};

export function getHTMLElementAsButtonProps({
  onClick,
  disabled = false,
  allowTabWhenDisabled = false,
  activateOnSpace = true,
}: A11yButtonOptions = {}) {
  const onKeyDown: React.KeyboardEventHandler = (e) => {
    if (disabled) return;
    if (e.key === "Enter") {
      e.preventDefault();
      // Let React dispatch onClick normally by calling .click() on target if possible
      const el = e.currentTarget as any;
      if (el && typeof el.click === "function") el.click();
      else onClick?.(e as any);
    }
    if (activateOnSpace && (e.key === " " || e.key === "Spacebar")) {
      e.preventDefault();
    }
  };

  const onKeyUp: React.KeyboardEventHandler = (e) => {
    if (disabled) return;
    if (activateOnSpace && (e.key === " " || e.key === "Spacebar")) {
      e.preventDefault();
      const el = e.currentTarget as any;
      if (el && typeof el.click === "function") el.click();
      else onClick?.(e as any);
    }
  };

  return {
    role: "button" as const,
    tabIndex: disabled && !allowTabWhenDisabled ? -1 : 0,
    "aria-disabled": disabled,
    onClick,
    onKeyDown,
    onKeyUp,
  };
}
